import React from 'react';
import { connect } from 'react-redux';
import { manageBgValue } from './state/cellValue';
import './cellBackground.css';
import { updateSquaresState, updateCommands } from './state/tableSquaresState';
import { updateCirclesState } from './state/tableCirclesState';
import { isNotExpanded } from "./state/rightMenuExpanded";
import { hideAlert } from "./state/setAlert";


class CellBackground extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value,
            id: this.props.id,
        };

        this.handleCommandClick = () => {
            if (this.props.bgValue.value) {
                this.props.increaseNum();
                this.props.updateCommands(this.props.posX, this.props.posY, this.props.bgValue.id)
            }
        };

        this.hideRightMenu = () => {
            let buttonsContainer = document.getElementById('rightMenuButtonsContainer');
            let activeButton = document.getElementsByClassName('active-button')[0];
            let details = document.getElementsByClassName('show')[0];
            buttonsContainer.classList.remove('expand-left');
            activeButton.classList.remove('active-button');
            details.classList.remove('show');
            this.props.isNotExpanded();
        };

        this.handleClick = e => {
            if (this.props.menu) {
                this.props.hideAlert();
                let activeCell = document.getElementsByClassName('active-cell')[0];
                if (activeCell) {
                    activeCell.classList.remove('active-cell')
                }
                e.currentTarget.classList.add('active-cell');
                this.props.manageBgValue('ACTIVE_BG_VALUE', this.state.value, this.props.id)
            }
            else {
                this.props.increaseNum();
                this.updateMataState();
            }
            if (this.props.isMenuExpanded === 'IS_EXPANDED') {
                this.hideRightMenu();
            }
        };
        this.updateMataState = () => {
            let posX = this.props.posX;
            let posY = this.props.posY;
            let id = this.props.bgValue.id;

            if (this.props.activeTable === 'SQUARES') {
                this.props.updateSquaresState(posX, posY, id);
            }
            else if (this.props.activeTable === 'CIRCLES') {
                this.props.updateCirclesState(posX, posY, id);
            }
        };
    }

    render() {
        let krazek = !this.props.menu ? this.props.krazki.find(function (krazek) {
            return (krazek.id === this.props.krazekId)
        }.bind(this)) : '';

        const isSquare = (this.props.id && this.props.id.startsWith('z')) || (this.props.krazekId && this.props.krazekId.startsWith('z'));

        let style = {
            backgroundImage: this.props.value ? "url('/akademia/image/krazki/" + this.props.value + "')" : "url('/akademia/image/krazki/" + krazek.path + "')",
        };

        return (
            this.props.menu ?
                <div style={style} key={this.props.key} onMouseDown={this.handleClick.bind(this)}
                    className={`li-content cell-content cell-content-menu ${isSquare ? 'without-border-radius' : ''}`}>
                </div>
                :
                this.props.command ?
                    <td key={this.props.key} onMouseDown={this.handleCommandClick} className="single-grid command-grid">
                        <div style={style} className="cell-content command-line without-border-radius"></div>
                    </td>
                    :
                    <td onMouseDown={this.handleClick.bind(this)}
                        className={this.props.table ? "single-circle" : "single-grid"}
                        style={this.props.cellStyle}
                        key={this.props.key}
                        tab-y={this.props.tabY}
                        tab-x={this.props.tabX}
                    >
                        <div style={style} className={"cell-content without-border-radius"}>
                        </div>
                    </td>
        )
    }
}

export default connect(
    state => ({
        bgValue: state.manageBgValue,
        krazki: state.krazki,
        mataSquares: state.mataSquares,
        mataCircles: state.mataCircles,
        activeTable: state.activeTable,
        isMenuExpanded: state.rightMenuExpanded.type
    }),
    { manageBgValue, updateSquaresState, updateCirclesState, isNotExpanded, hideAlert, updateCommands }
)(CellBackground)



// WEBPACK FOOTER //
// ./src/CellBackground.js